export enum CallFilter {
    NO_FILTER,
    INBOUND_ANSWERED,
    INBOUND_MISSED,
    OUTBOUND_ANSWERED,
    OUTBOUND_MISSED,
}
